import React from 'react';
import {FormattedMessage} from 'react-intl';
import CustomersListItem from '../CustomersListItem';
import {RivhitCustomer} from '../../../../common/types';
import styles from './CustomersList.module.scss';

export interface CustomersListProps {
  data: RivhitCustomer[];
}

const EmptyListMessage = () => (
  <div className={styles.emptyMessage}>
    <FormattedMessage
      id={'orderInvoice-modal-search-customers-message-emptyList'}
      defaultMessage={'No existing customers were found, please fill in the fields manually'}
    />
  </div>
)

const CustomersList = ({data}: CustomersListProps) => {
  const render = (data: RivhitCustomer[]) => {
    return data.map((customer, index) => <CustomersListItem {...customer} key={index}/>);
  };

  return (
    <>
      <div className={styles.lineContainer}>
        <div>
          <FormattedMessage
            id={'orderInvoice-modal-search-customers-header-customerName'}
            defaultMessage={'Customer name'}
          />
        </div>
        <div>
          <FormattedMessage
            id={'orderInvoice-modal-search-customers-header-idNumber'}
            defaultMessage={'ID'}
          />
        </div>
        <div>
          <FormattedMessage
            id={'orderInvoice-modal-search-customers-header-phoneNumber'}
            defaultMessage={'Phone number'}
          />
        </div>
        <div>
          <FormattedMessage
            id={'orderInvoice-modal-search-customers-header-address'}
            defaultMessage={'Address'}
          />
        </div>
        <div>
          <FormattedMessage
            id={'orderInvoice-modal-search-customers-header-actions'}
            defaultMessage={'Actions'}
          />
        </div>
      </div>
      <div className={styles.customersListContainer}>
        {(data.length === 0) ? <EmptyListMessage/> : render(data)}
      </div>
    </>
  );
};

export default CustomersList;
